import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import dealermodule from './modules/dealermodule/components/dealermodule.vue';
import Settings from './models/settings.js';
import GmapCluster from 'vue2-google-maps/src/components/cluster';
import VueRouter from 'vue-router';

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyDrtSOuffsR19gt2CLtwDplQ54B8879APA',
        libraries: 'places'
    },
    installComponents: true
});

Vue.component('GmapCluster', GmapCluster);

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history'
});

function init() {
    var objSettings = new Settings(window.settings || {});

    var elDealerModule = document.querySelector('.vue-dealermodule');
    if (elDealerModule !== null) {
        new Vue({
            el: '.vue-dealermodule',
            render: h => h(
                dealermodule,
                {
                    props: {
                        settings: objSettings
                    }
                }
            ),
            router
        });
    }
}

export default {
    init
};
